import * as React from 'react';
import {Helmet} from 'react-helmet';

import {headTitle} from 'shells/document/head-title';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

import {PageTitleBar} from '../../layout';

import styles from './email-extension-page.module.css';

export function EmailOutlookExtensionPage() {
    return (
        <>
            <Helmet>
                <title>{headTitle('Outlook Extension')}</title>
            </Helmet>
            <PageTitleBar
                title='Outlook Extension'
                subheaderPrimaryText='Enhance your Outlook email inbox with the Nutshell Outlook Add-in'
            />
            <div className='pad-32 background-white full-height'>
                <EmptyStateLarge
                    title='Enhance Outlook for Office 365 with Nutshell'
                    subtitle='See Nutshell contacts and create leads from Outlook.'
                    detailTextBullets={[
                        'Available for Microsoft 365 email accounts, install our Outlook Add-in for a connected Nutshell experience',
                        'Create Nutshell contacts and tasks from your inbox',
                        'See Nutshell timelines for email senders',
                    ]}
                    icon={
                        <img
                            alt=''
                            src='/include/images/email-marketing/email_inbox_empty_state_microsoft.png'
                            className={styles.icon}
                        />
                    }
                    cta={
                        <Link
                            variant='button-primary'
                            size='xlarge'
                            href='https://appsource.microsoft.com/en-us/product/office/wa104381213'
                            // @ts-expect-error
                            target='_blank'
                        >
                            Install the Nutshell Outlook Add-in
                        </Link>
                    }
                />
            </div>
        </>
    );
}
